import { utils, write } from 'xlsx';

import { downloadFile } from '@vestigas/utils';

export type ExcelData = unknown[][];

/**
 * Exports data to an Excel file.
 *
 * @param {unknown[][]} data - A 2D array of data to be exported.
 * @param {string} [fileName='VESTIGAS export'] - The name of the exported Excel file.
 * @return {void}
 */
export const exportExcel = (data: ExcelData, fileName = 'VESTIGAS export') => {
  const workSheet = utils.aoa_to_sheet(data);

  const workBook = {
    Sheets: {
      data: workSheet,
      cols: [],
    },
    SheetNames: ['data'],
  };

  const excelBuffer = write(workBook, {
    bookType: 'xlsx',
    type: 'array',
  });
  const excelBlob = new Blob([excelBuffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
  });

  downloadFile(excelBlob, `${fileName}.xlsx`);
};
